import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * PasswordInput - Reusable password input with show/hide toggle
 */
const PasswordInput = ({ 
  value, 
  onChange, 
  required = false, 
  placeholder = '',
  id,
  autoComplete = 'current-password'
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="password-input-wrapper">
      <input
        type={showPassword ? 'text' : 'password'}
        className="form-input"
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        id={id}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        className="password-toggle-btn"
        onClick={togglePasswordVisibility}
        aria-label="Toggle password visibility"
        tabIndex={0}
      >
        {showPassword ? 'Hide' : 'Show'}
      </button>
    </div>
  );
};

PasswordInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  autoComplete: PropTypes.string,
};

export default PasswordInput;
